import React, {useRef, useState} from 'react';

import Popup from "reactjs-popup";
import useScroll from "ubs-framework/v2/hooks/useScroll";
import * as Icon from "ubs-icons";
import {COLOR} from "ubs-framework/v2/common/constant";
import {FilterSelect} from "ubs-framework/v2/common/UFilters/FilterSelect/filter-select";

const DropDownFilter = React.memo((props) => {
    const popupRef = useRef(null)
    const [name, setName] = useState('')
    const handle = {
        blur: e => {
            if (name) props?.onChange(name)
        },
        changeName: (e, type) => {
            if (['resignationReason', 'terminationReason', 'bankName', 'job', 'source'].includes(props?.type)) setName(e?.label)
            else setName(e?.value)
        },
        clearData: e => {
            e.stopPropagation()
            props?.onChange('')
            if (popupRef?.current) popupRef?.current?.open()
        }
    }

    useScroll(document.getElementsByClassName('u_import-scroll')[0], (e) => {
        if (popupRef.current) popupRef.current.close()
    });

    return (
        <React.Fragment>
            <Popup
                ref={popupRef}
                trigger={open => (
                    <div className="u_import-data-input">
                        <p className="u_small-font u_cp  u_flex u_align-center" onClick={(e) => handle.clearData(e)}>
                            <span className="u_mr-5 u_flex-1">{props?.errorTitle || props?.placeholder}</span>
                            <Icon.DownArrow fill={COLOR.u_title} size={14}/>
                        </p>
                    </div>
                )}
                position="bottom center"
                closeOnDocumentClick
                closeOnEscape
                className="u_popover-container"
                arrow={false}
                contentStyle={{zIndex: 10001}}
                onClose={handle.blur}
            >
                <FilterSelect
                    params={{
                        menuIsOpen: true,
                        options: props?.option,
                        // value: _FESR?.department,
                        onChange: (e) => handle.changeName(e, props?.type)
                    }}
                    type={props?.iconType}
                />
            </Popup>
        </React.Fragment>
    );
});

export default DropDownFilter;
